﻿import { ServiceRegistry } from "./registry/service.registry";
import { FrameSystem } from "./systems/frame.system";
import { HTMLSystem } from "./systems/html.system";
import { InputSystem } from "./systems/input.system";
import { SystemBase } from "./systems/system.base";
import { Gpu } from "./webgpu/gpu";

export class GraphicsApp {

    systems = new ServiceRegistry<SystemBase>();


    deltaTime: number = 0;
    time: number = 0;


    constructor() {

    }

    async run(): Promise<void> {

        await Gpu.initGpu();

        this.systems.add(FrameSystem);
        this.systems.add(InputSystem);
        this.systems.add(HTMLSystem, document.body);

        requestAnimationFrame(this.frame);
    }

    private frame = () => {

        const oldTime = this.time;

        this.time = performance.now() * 1000;
        this.deltaTime = this.time - oldTime;

        this.systems.forEach(e => e.update(this.time, this.deltaTime));

        this.systems.forEach(e => e.endOfFrame());

    }
}